// Convert a black list to a white list or vice versa
import type { CheckboxState } from '~/common/components/accountnumbers'
import type { Product } from '~/common/model/capabilities'

export const inverseSelectedKeys = (selectedKeys: string[], sourceData: { key: string }[]) =>
  sourceData.filter((item) => !selectedKeys.includes(item.key)).map((item) => item.key)

export const inverseSelectedProducts = (selectedProducts: Product[], allProducts: Product[]) =>
  allProducts.filter((p) => !selectedProducts.some((sp) => sp.value === p.value))

export const inverseSelectedProductKeys = (selectedProductKeys: string[], allProducts: Product[]) =>
  allProducts.filter((p) => !selectedProductKeys.includes(p.value))

export const getCheckboxState = (selectedProducts: any[], allProducts: any[]): CheckboxState => {
  const isAllSelected = selectedProducts.length === allProducts.length
  const isNoneSelected = selectedProducts.length === 0
  return isAllSelected ? 'checked' : isNoneSelected ? 'unchecked' : 'indeterminate'
}

export const containsKey = (products: Product[], key: string) => products.some((product) => product.value === key)
